export const isSelectionAutomatic = (selection) =>
  selection?.delivery_method === 'automatic';

export const isSelectionManual = (selection) =>
  selection?.delivery_method === 'manual';
